
const subscriptionBtn = document.getElementById('subscription_btn');
const cancelSubscriptionBtn = document.getElementById('unsubscribe_btn');


document.querySelector('input.billing__switch').addEventListener('change', function (event) {
    const monthlyPrices = document.querySelectorAll('.monthly_price_block');
    const yearlyPrices = document.querySelectorAll('.yearly_price_block');
    if (event.target.checked) {
        subscriptionBtn.setAttribute("data-key", "standard_yearly");
        monthlyPrices.forEach(p => p.classList.add('hidden'));
        yearlyPrices.forEach(p => p.classList.remove('hidden'));
    } else {
        subscriptionBtn.setAttribute("data-key", "standard_monthly");
        monthlyPrices.forEach(p => p.classList.remove('hidden'));
        yearlyPrices.forEach(p => p.classList.add('hidden'));
    }
});

document.getElementById("plans_btn").addEventListener("click", async function() {
    try {
        clarity("set", "plans", "open");
    } catch (e) {}
    document.getElementById('limit_error').classList.add("hidden");
    document.getElementById("subscription_modal").classList.remove("hidden");
});

document.getElementById("plans_modal_close").addEventListener("click", function() {
    document.getElementById("subscription_modal").classList.add("hidden");
});

function startPayment(event) {
    let btn = event.currentTarget;
    // Disable the button and change the text to show that the action is in progress
    btn.disabled = true;
    btn.classList.add('bg-gray-500', 'cursor-not-allowed');
    btn.classList.remove('bg-accent', 'hover:bg-accent-hover');

    // Check if the billing switch is checked (yearly billing)
    let price_key = btn.getAttribute("data-key");

    fetch('https://zima-backend.farawaytech.com/v1/subscription/checkout', {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            price_key: price_key
        })
    }).then(function (response) {
        if (response.ok) {
            return response.json();
        } else {
            throw new Error('Network response was not ok');
        }
    }).then(function (data) {
        // remove disabled in case user clicks back
        btn.disabled = false;
        btn.classList.add('bg-accent', 'hover:bg-accent-hover');
        btn.classList.remove('bg-gray-500', 'cursor-not-allowed');
        window.location.href = data.redirect_url;
    }).catch(function (error) {
        console.error('Error:', error);
        // If there is an error, enable the button and change the text back
        btn.disabled = false;
        btn.classList.add('bg-accent', 'hover:bg-accent-hover');
        btn.classList.remove('bg-gray-500', 'cursor-not-allowed');
    });
}

subscriptionBtn.addEventListener('click', startPayment);
document.getElementById('pay_btn').addEventListener('click', startPayment);


cancelSubscriptionBtn.addEventListener('click', function () {

    fetch('https://zima-backend.farawaytech.com/v1/subscription/cancel', {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(function (response) {
        if (response.ok) {
            return response.json();
        } else {
            throw new Error('Network response was not ok');
        }
    }).then(function (data) {
        alert("Subscription canceled");
    }).catch(function (error) {
        alert("Could not cancel subscription");
    });
});

function loadPayPal() {
    if (window.paypal) {
        return Promise.resolve();
    }
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = "https://www.paypal.com/sdk/js?client-id=AckuT-4o7lYu3bAffQWOPdjxuQJklVnsn4oflwBTX3V_NcNi8Tc4Qtex8-QLpc-R_v7IOLzSAVLAHT62&vault=true&intent=subscription";
        script.setAttribute('data-sdk-integration-source', 'button-factory');
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
    });
}